<template>
  <div class="hotel_container">
    <!-- 确保 Loading 组件正确绑定 submitLoading -->
    <Loading :loading="submitLoading" />
    <el-row v-if="showPayOrder">
      <el-col :span="24">
        <div
          v-if="$objBaseInfo.channelId === 'WEB'"
          class="grid-content content_size"
          style="margin-top: 1rem"
        >
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="height: 5rem; line-height: 5rem"
          >
            <el-breadcrumb-item>{{
              $t("RESULT.SEARCHHOTEL")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("GUARANTEE.SELECTHOTEL")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("DETAIL.DETAILPAGE")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t("BOOKING.BOOKING") }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("GUARANTEE.GUARANTEE")
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="warning_sty content_size align_center">
          <span class="fontstyle" style="margin-left: 1rem">
            {{ $t("GUARANTEE.REMINDER") }}
          </span>
        </div>
        <div id="nav2">
          <div class="box">
            <span class="big_font">{{ showHotelName(orderInfo.bookParam.hoteDescriptiveInfo.name) }}</span>
            <el-row :gutter="10" style="margin: 1.3rem 1.3rem 0;border-bottom: 0.2rem dotted #979797;">
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font label_name_text">{{ $t("GUARANTEE.CHECKINDATE") }}
                    <span class="small_font">{{ orderInfo.checkInAt }}</span>
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font label_name_text">{{ $t("GUARANTEE.CHECKOUTDATE") }}
                    <span class="small_font">{{ orderInfo.checkOutAt }}</span>
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">
                    {{ $t('GUARANTEE.ROOMNUMBER_PREFIX') }}
                    <span class="small_font">{{ orderInfo.nights }}</span>
                    {{ $t('GUARANTEE.ROOMNUMBER_SUFFIX') }}
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="5" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">
                    {{ $t('GUARANTEE.NIGHTS_PREFIX') }}
                    <span class="small_font">{{ orderInfo.roomCount }}</span>
                    {{ $t('GUARANTEE.NIGHTS_SUFFIX') }}
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="4" style="padding-left: 0">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font label_name_text">{{ $t("GUARANTEE.TOTALAMOUNT") }}
                    <span class="small_font">{{this.$objBaseInfo.defaultCurrencySign + orderInfo.totalPrice}}</span>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 房间信息 -->
          <div class="box">
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("GUARANTEE.ROOMTYPE") }}</span>
              <span class="small_font mobile_span_room">{{orderInfo.bookParam.roomDescriptiveInfo.name[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]}}</span>
            </div>
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("BOOKING.DESCRIPTION") }}</span>
              <span class="mobile_span_room"><span class="small_font">{{ roomTypeInfo }}</span></span>
            </div>
            <div class="grey_small_font item free_font">
              <span class="label_name_text">{{ $t("GUARANTEE.BREAKFAST1") }}</span>
              <!-- 早餐 -->
              <span class="small_font mobile_span_room" v-if="orderInfo.breakfastQty == 0">{{ $t("BOOKING.NOBREAKFAST") }}</span>
              <span class="small_font" v-if="orderInfo.breakfastQty > 0 && orderInfo.breakfastQty < 99">
                {{$t("BOOKING.BREAKFASTNUM", {num: orderInfo.breakfastQty,})}}
              </span>
              <span class="small_font" v-if="orderInfo.breakfastQty == 99">{{ $t("BOOKING.BREAKFAST99") }}</span>
            </div>
          </div>
          <!-- 入住人信息 -->
          <div class="box">
            <!-- 入住人姓名 -->
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("GUARANTEE.NAME") }}</span>
              <span class="small_font mobile_span_room">{{roomGuests.name}}</span>
            </div>
            <!-- 电话 -->
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("GUARANTEE.TEL") }}</span>
              <span class="small_font mobile_span_room">{{ roomGuests.contact.mobile }}</span>
            </div>
            <!-- 邮箱 -->
            <div class="grey_small_font item free_font">
              <span class="label_name_text">{{ $t("GUARANTEE.EMAIL") }}</span>
              <span class="small_font mobile_span_room">{{roomGuests.contact.email}}</span>
            </div>
          </div>
          <!-- 服务费信息 -->
          <div class="box">
            <!-- 服务费 -->
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("MANUAL.SERVICEFREE") }}</span>
              <span class="small_font">¥{{ serviceFees.serviceFeeAmount }}</span>
            </div>
            <!-- 紧急服务费 -->
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("CONFIRMATION.EMERGENCY") }}</span>
              <span class="small_font">¥{{ serviceFees.emergencyServiceFee }}</span>
            </div>
            <!-- 刷卡手续费 -->
            <div class="grey_small_font free_font">
              <span class="label_name_text">{{ $t("CONFIRMATION.CARDSWIPEFEE") }}</span>
              <span class="small_font">¥{{cardswipefee}}</span>
            </div>
            <!-- 应付总额 -->
            <div class="grey_small_font item free_font" style="font-weight: bold;font-size: 20px;">
              <span class="label_name_text">{{ $t("CONFIRMATION.TOTALPRICE") }}</span>
              <span class="small_font" style="line-height: 4rem;font-size: 20px;">¥{{orderTotalPrice()}}</span>
            </div>
          </div>
          <PCPay :cusDepProPayRule="cusDepProPayRule" v-if="$objBaseInfo.channelId === 'WEB'" ref="PC_child"></PCPay>
          <H5Pay :cusDepProPayRule="cusDepProPayRule" v-if="$objBaseInfo.channelId === 'MOBILE'" ref="H5_child"></H5Pay>
        </div>
      </el-col>
      <ConfirmBoxs
        :centerDialogVisible="confirmFlag"
        :confirmMsg="confirmMsg"
        :icon="confirmIcon"
        @setConfirmFlag="setConfirmFlag"
      ></ConfirmBoxs>
    </el-row>
    <el-row v-else>
      <div class="err-item">
        <div class="err-img">
          <img
            src="../../icon/img/pay-result-tip.png"
            class="img-item"
            alt="错误"
          />
        </div>
        <div class="errorContainer">订单已过期，请重新支付</div>
      </div>
    </el-row>
  </div>
</template>
  
  <script>
import { getContract,getOrderStatus } from "@/api/bookingData.js";
import { getCreditCardLookup,getBankList,getCreditCardAdd,verifySigning,creditCardDelete,getCusDepProPayRule, getSwipeRates } from "@/api/platformData.js";;
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import PCPay from "./PC/PCPay.vue";
import H5Pay from "./H5/H5Pay.vue";
import Loading from "@/components/Loading.vue";
import { hideElement } from "@/utils/utils.js";
import { showDialog } from "vant";
export default {
  name: "PayOrder",
  components: {
    ConfirmBoxs,
    Loading,
    PCPay,
    H5Pay,
  },
  provide() {
    return {
      PayOrderInfo: this,
    }
  },
  data() {
    return {
      showPayOrder: true,
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
      submitLoading: false,
      checked: "",
      orderInfo: {
        bookParam: {
          hoteDescriptiveInfo: {
            name: [],
          },
          roomDescriptiveInfo: {
            name: [],
          },
        },
      },
      bookParam: {}, //创建订单需要的信息
      roomGuests: {
        contact: {
          mobile: "",
          email: "",
        },
      }, //入住人信息
      bookingAgents: {}, //预定人信息
      orderIdTo: "", //订单ID
      roomTypeInfo: "",
      payList: [
        { id: 1, name: this.$t("PAYMENTTYPE.Alipay") },
        { id: 2, name: this.$t("PAYMENTTYPE.WeChatPay") },
        { id: 3, name: this.$t("PAYMENTTYPE.KQ") },
      ],
      payInfo: {
        currencyCode: "GHS",
      },
      timer: "", //定时器
      creditCardInfo:[],
      creditCardType: [
        { id: "AMEX", name: "AMEX", value: "AX" },
        { id: "DINERS", name: "DINERS", value: "DC" },
        { id: "JCB", name: "JCB" , value: "JC"},
        { id: "MASTER", name: "MASTER" , value: "CA"},
        { id: "VISA", name: "VISA" , value: "VI"},
        { id: "UnionPay", name: "UnionPay", value: "UP" },
      ],
      cardType:[
        { id: "0", name: "身份证" },
        { id: "1", name: "护照" },
        { id: "2", name: "军官证" },
        { id: "3", name: "士兵证" },
        { id: "4", name: "港澳台通行证" },
        { id: "5", name: "临时身份证" },
        { id: "6", name: "户口本" },
        { id: "7", name: "其他类型证件" },
        { id: "9", name: "警官证" },
        { id: "12", name: "外国人居留证" },
        { id: "15", name: "回乡证" },
        { id: "16", name: "企业营业执照" },
        { id: "17", name: "法人代码证" },
        { id: "18", name: "台胞证" },
      ],
      bankInfo:[],
      isSigning:false,
      kqContractToken:"",
      tcapchaTimer:"",
      cusDepProPayRule:{
        isAlipay:false,
        isH5Alipay:false,
        isKQPay:false,
        isH5KQPay:false,
        isWeiXinPay:false,
        isH5WeiXinPay:false,
        payShowType:false,
        isCTAPay:false,
        isH5CTAPay:false,
      },// 支付配置
      serviceFees:{
        serviceFeeAmount:0,
        emergencyServiceFee:0,
        totalPrice:0,
      },
      cardswipefee:0.00,
    };
  },
  created() {
    if (this.$objBaseInfo.channelId === "MOBILE") {
      this.$nextTick(() => {
        //不显示回退按钮
        let goHistray = document.querySelector(".van-nav-bar__left");
        goHistray.setAttribute("style", "display:none");
      });
    }
  },
  watch: {},
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    this.getBankList();
    let createpayOrderInfo = window.sessionStorage.getItem("payOrderInfo");
    if (!createpayOrderInfo) {
      return false;
    }
    //移除面包屑的样式
    let classList = document.querySelectorAll(".el-breadcrumb__inner");
    for (const iterator of classList) {
      iterator.removeAttribute("class");
    }
    this.orderInfo = JSON.parse(createpayOrderInfo);
    this.serviceFees.serviceFeeAmount = this.orderInfo.bookParam.serviceFees.amount;
    this.serviceFees.emergencyServiceFee = this.orderInfo.bookParam.emergencyServiceFee;
    this.serviceFees.totalPrice = this.orderInfo.bookParam.totalPrice;
    this.getRoomTypeInfo();
    this.roomGuests = this.orderInfo.bookParam.guestInfo[0];
    this.bookingAgents = this.orderInfo.bookParam.bookingAgent[0];
    this.orderDetail();
    this.startTime();
    this.getUserCreditCard();
    this.GetCusDepProPayRule();
  },
  methods: {
    showHotelName(hotelName) {
      if (this.$objBaseInfo.sourceType == "CRM") {
        if (
          this.$objBaseInfo.isGATCity ||
          this.$objBaseInfo.destinationType == "I"
        ) {
          return hotelName["zh-CN"] + "(" + hotelName["en"] + ")";
        }
      }
      return hotelName[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
    },
    
    orderTotalPrice() {
      const total = parseFloat(this.orderInfo.totalPrice) + this.cardswipefee;
      return Math.round(total * 100) / 100; // 保留两位小数
    },
    // 房型信息拼接
    getRoomTypeInfo() {
      let info_arr = [];
      if (this.orderInfo.floor && this.orderInfo.floor.trim() != "") {
        info_arr.push(
          this.$t("BOOKING.ROOMDESCRIPTION", {
            floor: this.orderInfo.floor,
          })
        );
      }
      if (this.orderInfo.area && this.orderInfo.area.trim() != "") {
        info_arr.push(
          this.$t("BOOKING.ROOMDESCRIPTIONAREA", {
            area: this.orderInfo.area,
          })
        );
      }
      if (this.orderInfo.wifi || this.orderInfo.wifi == 0) {
        this.$t("COMMONPARAM.WIFI.WIFI" + this.orderInfo.wifi) !=
        "COMMONPARAM.WIFI.WIFI" + this.orderInfo.wifi
          ? info_arr.push(
              this.$t("COMMONPARAM.WIFI.WIFI" + this.orderInfo.wifi)
            )
          : "";
      }
      if (this.orderInfo.window || this.orderInfo.window == 0) {
        this.$t("COMMONPARAM.WINDOW.WINDOW" + this.orderInfo.window) !=
        "COMMONPARAM.WINDOW.WINDOW" + this.orderInfo.window
          ? info_arr.push(
              this.$t("COMMONPARAM.WINDOW.WINDOW" + this.orderInfo.window)
            )
          : "";
      }
      this.roomTypeInfo = info_arr.join(", ");
    },
    setConfirmFlag() {
      this.confirmFlag = false;
      if (this.orderIdTo != "") {
        this.toCon(this.orderIdTo);
      }
    },
    async orderDetail() {
      const bookingId = this.orderInfo.bookParam.bookingId;
      let orderParam = {
        params: {
          bookingId: bookingId
        },
      };
      // this.detailLoading = false;
      let that = this;
      await getOrderStatus(orderParam)
        .then((res) => {
          if (res.code === 200) {
            if (!res.message.includes("PENDING_BOOKING")) {
              that.toOrderDetails();
            }
          }
        })
        .catch((err) => {
          console.log("订单详情查询异常:", err.objError);
        });
    },
    startTime() {
      this.timer = setInterval(this.orderDetail, 5000);
    },
    //跳转订单详情页
    toOrderDetails() {
      this.$router.push({
        name: "Confirmation",
        query: {
          orderId: this.orderInfo.bookParam.bookingId,
          //customerCode: row.customerCode,
          sourceType: this.$objBaseInfo.sourceType,
          isJumpLink: "false",
        },
      });
    },

    openLoading() {
      this.submitLoading = true;
    },
    closeLoading() {
      this.submitLoading = false;
    },
    async getUserCreditCard(){
      let params = {
        params: {
          travelerCode: this.orderInfo.bookParam.bookingAgent[0].userId,
          encrypt:true,
          page: 1,
          per_page: 20,
        },
      };
      await getCreditCardLookup(params)
        .then((res) =>{
          if (res.code === 200) {
            if (res.data.error.code == 0) {
              for(var i = 0; i < res.data.items.length; i++){
                var joinBank = "";
                var val = res.data.items[i];
                var bankInfo = this.bankInfo.filter(function(item,index,array){
                  if(item.bankCode == val.bankCode){
                    return item;
                  } ;
                });
                if(bankInfo.length > 0){
                  val.name= bankInfo[0].bankName;
                  joinBank = bankInfo[0].bankName.replace(val.bankCode,"") + " (" + val.creditCardNo.substr(val.creditCardNo.length - 4, 4) + ")";
                }
                val.joinBank = joinBank;
                val.tel= val.creditCardNo;
              }
              this.creditCardInfo = res.data.items;
            }
          }
        });
    },
    async GetCusDepProPayRule(){
      let isDom = '';
      if(this.orderInfo.isInternational){
        isDom = "JI";
      }else if(this.orderInfo.isGAT){
        isDom = "GAT";
      }else{
        isDom = "JD";
      }
      let params = {
        params: {
          logindId: this.orderInfo.bookParam.bookingAgent[0].userId,
          IsDom:isDom
        },
      };
      await getCusDepProPayRule(params)
        .then((res) =>{
          if (res.code === 200) {
            if (res.data.error.code == 0) {
              this.cusDepProPayRule.isAlipay = res.data.isAlipay;
              this.cusDepProPayRule.isH5Alipay = res.data.isH5Alipay;
              this.cusDepProPayRule.isKQPay = res.data.isKQPay;
              this.cusDepProPayRule.isH5KQPay = res.data.isH5KQPay;
              this.cusDepProPayRule.isWeiXinPay = res.data.isWeiXinPay;
              this.cusDepProPayRule.isH5WeiXinPay = res.data.isH5WeiXinPay;
              this.cusDepProPayRule.isCTAPay = res.data.isCTAPay;
              this.cusDepProPayRule.isH5CTAPay = res.data.isH5CTAPay;
              if(this.cusDepProPayRule.isH5Alipay || this.cusDepProPayRule.isH5KQPay || this.cusDepProPayRule.isH5WeiXinPay || this.cusDepProPayRule.isH5CTAPay){
                this.cusDepProPayRule.payShowType=true;
              }
            }
          }
        });
    },
    // returnStr(type,b){
    //   var str = "";
    //   switch (type)
    //   {
    //     case "Card":
    //         if (b.length > 10){
    //             str = str.concat(b.substr(0, 6), "******", b.substr(b.length - 4, 4));
    //         }
    //         else{
    //           if (str.length > 6)
    //               str = str.concat(b.substr(0, b.length - 6), "******");
    //           else
    //               str = b;
    //         }
    //         break;
    //     case "IDCard":
    //         str = b.length > 6 ? str.concat(b.substr(0, 3), "******", b.substr(b.length - 3, 3)) : b;
    //         break;
    //     case "Name":
    //         str = b.length > 1 ? str.concat("*", b.substr(1, b.length - 1)) : b;
    //         break;
    //     case "Date":
    //         str = b.length > 2 ? str.concat("*", b.substr(2, b.length - 2)) : b;
    //         break;
    //     case "Phone":
    //         str = b.length > 6 ? str.concat(b.substr(0, 3), "******", b.substr(b.length - 3, 3)) : b;
    //         break;
    //   }

    //   return str;
    // },
    addUserCreditCardCallBack(data){
      getCreditCardAdd(data)
      .then((res) => {
        if (res.code == 200) {
          this.getUserCreditCard().then(()=>{
            if(data.source == "H5")
            {
              this.$refs.H5_child.KQPay();
            }else{
              this.$refs.PC_child.KQPay();
            }
          });
        }else{
          if(data.source == "H5")
          {
            showDialog({
              message: res.message,
            });
          }else{
            this.confirmFlag = true;
            this.confirmMsg = res.message;
          }
        }
      });
    },
    deleteUserCreditCardCallBack(data){
      creditCardDelete(data)
      .then((res) => {
        if (res.code == 200) {
          if(res.data){
            this.getUserCreditCard().then(()=>{
              if(data.source == "H5"){
                this.$refs.H5_child.KQPay();
              }else{
                this.$refs.PC_child.KQPay();
              }
            });
          }else{
          if(data.source == "H5"){
            showDialog({
              message: this.$t("PAYORDERPAGE.DeleteCreditCardFailed"),
            });
          }else{
            this.confirmFlag = true;
            this.confirmMsg = this.$t("PAYORDERPAGE.DeleteCreditCardFailed");
          }
        }
        }
      });
    },
    getBankList(){
      getBankList()
      .then((res) =>{
        this.bankInfo = res;
      });
    },
    verifyBankSigning(data){
      verifySigning(data)
      .then((res) =>{
        if (res.code == 200) {
          this.isSigning = res.data;
          if(data.params.source == "H5"){
            this.$refs.H5_child.verifyBankSigningCallBack();
          }
        }
      });
    },
    kqContract(data){
      getContract(data)
      .then((res) =>{
        if (res.code == 200) {
          //this.isSigning = res.data;
          if(res.data.code == "0000"){
            this.kqContractToken = res.data.tradeNo;
          }else{
            if(data.source == "H5"){
              showDialog({
                message: res.data.msg,
                theme: 'round-button',
              });
            }
            if(data.source == "PC"){
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'warning',
                center: true,
                offset:500
              });
            }
          }
        }
      });
    },
    getSwipeRates(payGateway){
      const param = {
        params:{
          userCode:this.orderInfo.bookParam.customerCode,
          source: this.$objBaseInfo.sourceType,
          price: this.serviceFees.totalPrice,
          serviceFee: parseFloat(this.serviceFees.serviceFeeAmount) + parseFloat(this.serviceFees.emergencyServiceFee),
          payGateway,
        }
      };
      getSwipeRates(param)
        .then((res) => {
          if (res.code === 200) {
            this.cardswipefee = res.data.paymentPrice;
          }
        });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
  
  <style scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .label_name_text {
    width: 13rem;
  }

  .mobile_span_room {
    max-width: 75%;
  }

  .hotel_container {
    overflow: hidden;
  }

  .s_btn_small_add {
    width: 17.6rem;
    background-color: #ffffff;
    color: #fc6640;
    border: 1px solid #fc6640;
  }

  .bg-purple-light {
    margin-bottom: 1rem;
    height: 8rem;
  }

  #nav2 {
    margin: 1.3rem 0;
  }

  #nav {
    margin-top: 1.3rem;
    background-color: #ffffff;
  }

  .big_font {
    width: 100%;
    white-space: normal;
    font-size: 1.8rem;
    font-family: PingFang SC, arial, helvetica,
      "helvetica neue", verdana, sans-serif;
    color: #333f48;
    line-height: 25px;
    margin-left: 1.3rem;
    margin-top: 1.3rem;
    display: inherit;
    padding-top: 13px;
    padding-right: 65rem;
    font-weight: bold;
  }

  #box1 {
    padding: 1.5rem 0;
  }

  #box2 {
    padding: 0 2rem;
  }

  .small_font {
    height: 2rem;
    font-size: 1.4rem;
    font-family: PingFang SC, arial, helvetica,
      "helvetica neue", verdana, sans-serif;
    color: #333f48;
    line-height: 2rem;
    margin-left: 1rem;
  }

  .grey_small_font {
    font-size:1.4rem;
    font-family: PingFang SC, arial, helvetica,
      "helvetica neue", verdana, sans-serif;
    color: #6f787e;
  }

  ::v-deep .el-form-item__label {
    text-align: left;
    font-size: 1.6rem;
    padding: 0;
    height: 3rem;
  }

  ::v-deep .el-input {
    font-size: 1.4rem;
  }

  .el-select-dropdown__item {
    font-size: 1.4rem !important;
  }

  ::v-deep .el-form-item__error {
    padding-top: 0;
  }

  .elongHint {
    color: red;
    font-size: 14px;
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .label_name_text {
    width: 12.8rem;
  }

  .s_btn_small_add {
    width: 17.6rem;
    background-color: #ffffff;
    color: #fc6640;
    border: 1px solid #fc6640;
  }

  .save-check {
    padding-left: 5rem;
  }

  .bg-purple-light {
    margin-bottom: 2rem;
    margin-left: 4rem;
  }

  #box1 {
    padding: 2rem 0;
  }

  #box2 {
    padding: 0 2rem;
  }

  .content_size {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  #nav2 {
    margin: 1.3rem 6rem;
    /* border: 10px solid #7F8C8D; */
  }

  #nav {
    margin: 1.3rem 6rem;
    background-color: #ffffff;
  }

  .big_font {
    height: 25px;
    white-space: nowrap;
    font-size: 1.8rem;
  }

  .small_font {
    height: 2rem;
    font-size: 14px;
    font-family: PingFang SC, arial, helvetica,
      "helvetica neue", verdana, sans-serif;
    color: #333f48;
    line-height: 2rem;
  }

  .grey_small_font {
    font-size: 14px;
    font-family: PingFang SC, arial, helvetica,
      "helvetica neue", verdana, sans-serif;
    color: #6f787e;
  }

  .big_font {
    /* width: 421px; */
    font-size: 18px;
    font-family: PingFang SC, arial, helvetica,
      "helvetica neue", verdana, sans-serif;
    font-weight: 600;
    color: #333f48;
    line-height: 25px;
    margin-left: 1.3rem;
    margin-top: 1.3rem;
    display: inherit;
    padding-top: 13px;
    padding-right: 65rem;
  }

  ::v-deep .el-form-item__label {
    text-align: left;
  }

  .elongHint {
    margin-left: 4rem;
    color: red;
    font-size: 14px;
  }
}

.holewidth {
  width: 100%;
}

.item {
  padding-bottom: 1.5rem;
  border-bottom: 0.2rem dotted rgb(151, 151, 151);
}

.bread_inner /deep/ .el-breadcrumb__inner {
  color: #fc6640;
}

.button_sty {
  width: 17.6rem;
  height: 5rem;
}

.myinput_inner /deep/ .el-input__inner {
  height: 100%;
  border-radius: 0;
}

.grey_input {
  /* width: 100%; */
  height: 0px;
  margin-top: -0.5rem;
  background: #e7e9ea;
  border-radius: 2px;
  /* border: 1px solid #e7e9ea; */
}

.inputMonth::-webkit-datetime-edit-text {
  color: blue;
  padding: 1.3rem;
}

.inputMonth::-webkit-datetime-edit-month-field {
  color: red;
}

.last_part {
  background-color: #f1e4c4;
}

#nav2 div {
  /* 占有比例 */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
}

#nav div {
  /* 占有比例 */
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
}

#box3 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  background: #ffffff;
}

.align_center {
  display: flex;
  align-items: center;
}

.warning_sty {
  height: 30px;
  background: #f1e4c4;
  border-top: 3px solid red;
}

.fontstyle {
  height: 2rem;
  font-size: 1.4rem;
  font-family: PingFang SC, arial, helvetica,
    "helvetica neue", verdana, sans-serif;
  /* font-weight: 600; */
  color: #333f48;
}

.myColor /deep/ .el-breadcrumb__inner {
  font-size: 1.4rem;
  font-family: PingFang SC, arial, helvetica,
    "helvetica neue", verdana, sans-serif;
  /* font-weight: 600; */
  color: #333f48;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.grid-content {
  min-height: 3rem;
}

.row-bg {
  padding: 1rem 0;
  background-color: #f9fafc;
}

.slash {
  background: linear-gradient(
    to top right,
    transparent 0%,
    transparent calc(50% - 1px),
    #c0c4cc 50%,
    transparent calc(50% + 1px),
    transparent 100%
  );
}

.card-input-icon :deep(.el-input__prefix) {
  right: 1rem;
  left: unset;
}

.card-input-icon :deep(.el-input__inner) {
  padding-left: 1rem;
}

::v-deep input.el-input__inner {
  height: 3rem !important;
  line-height: normal;
  transform: translateZ(0);
  outline: none;
}

.dialog_btn_y {
  background-color: #fc6640;
  color: #fff;
  border: 0px;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 0.3rem;
  font-family: Source-Sans-Bold;
}

.four_btn {
  width: 13rem;
  height: 4rem;
}

.grey_small_font span.small_font {
  color: #333f48;
}
.err-item,
.err-item .err-img {
  padding-top: 90px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.err-item .err-img {
  flex-direction: row;
  justify-content: center;
}
.err-item .errorContainer {
  color: #666;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 24px;
}
.err-item .err-img .img-item {
  width: 72px;
  margin-bottom: 24px;
}
.page-layout-main {
  width: 1180px;
  margin: 16px auto 0;
  min-height: 800px;
}
.free_font{
  margin-left: 1.3rem; 
  padding-top: 1.3rem; 
  display: flex
}
</style>
  